export const SET_REVIEW_DATA = 'SET_REVIEW_DATA';
export const ADD_REVIEW_DATA = 'ADD_REVIEW_DATA';
export const SET_PAGE_DATA = 'SET_PAGE_DATA';
export const SET_ACCOUNT_NAME = 'SET_ACCOUNT_NAME';
